import jwtDecode from "jwt-decode"

export const isAccessTokenExpire = (token) => {
    const obj = jwtDecode(token)
    
    if ((obj.exp * 1000) > Date.now()) {
        return false
    } else {
        return true
    }
}

export const isObjectValid = (obj) => {

    if(obj !== undefined && obj !== null && Object.keys(obj).length !== 0)
        return true
        
    return false
}